import { Icon, toast, useMediaQuery, useToast } from '@chakra-ui/react';
import { useContext, useEffect, useState } from 'react';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { HiCheckCircle } from 'react-icons/hi';
import { IoCloseCircleOutline } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import MaskedInput from 'react-text-mask';

import VisualizationContext from '../../../../../contexts/VisualizationContext';
import { api } from '../../../../../services/api';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { delay } from '../../../../../utils/delay';
import { isCpfValid } from '../../../../../utils/masks';
import { ConclusionCard } from '../components/ConclusionCard';
import { LayoutGestaoLeads } from '../components/LayoutGestaoLeads';

function CadastroVendedor() {
  const cpfMask = [
    /[0-9]/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/
  ];
  const toast = useToast();

  const [vendedor, setVendedor] = useState<any>({
    nome: null,
    email: null
  });
  const [cpf, setCPF] = useState('');
  const [loadingCPF, setLoadingCPF] = useState(false);
  const [exists, setExists] = useState(true);

  const [CpfRegistered, setCpfRegistered] = useState(false);
  const [errorMessageIfCpfRegistered, setErrorMessageIfCpfRegistered] =
    useState('');

  const [loadingVincular, setLoadingVincular] = useState(false);
  const [disableInputCPF, setDisableInputCPF] = useState(false);
  const [isMobile] = useMediaQuery('(max-width: 920px)');
  const [concluido, setConcluido] = useState(true);

  const getCpfData = async (userCpf: string) => {
    setLoadingCPF(true);

    try {
      const token = localStorage.getItem('tokenPortal');

      const { data } = await apiSensedia.get(
        `oportunidades-sulamerica/painel-leads/consulta-autonomo`,
        { headers: { cpf: userCpf } }
      );

      setExists(true);
      setVendedor({ ...vendedor, nome: data.nome });
    } catch (error: any) {
      if (error.response.status === 404) {
        setExists(false);
        setVendedor({
          nome: null,
          email: null
        });
      }

      if (error.response.status === 409) {
        setCpfRegistered(true);
        setErrorMessageIfCpfRegistered(error.response.data.data.error_message);
        setVendedor({
          nome: null,
          email: null
        });
      }
      // toast({
      //   position: 'top',
      //   description: 'Ocorreu um error, favor tente novamente',
      //   status: 'error',
      //   duration: 7000,
      //   isClosable: true
      // });
    }
  };

  const handleVincularUsuario = async () => {
    setLoadingVincular(true);

    try {
      if (vendedor.nome !== null) {
        const { data } = await apiSensedia.put(
          `oportunidades-sulamerica/painel-leads/vincular-usuario-autonomo`,
          { id: cpf }
        );
        const descricao =
          'Vendedor ' + vendedor.nome + ' foi adicionado com sucesso!!!!';
        toast({
          position: 'top',
          description: descricao,
          status: 'success',
          duration: 7000,
          isClosable: true
        });
        await delay(4000);
        location.pathname = '/corretor/leads/perfis';
      } else {
        const { data } = await apiSensedia.put(
          `oportunidades-sulamerica/painel-leads/enviar-email-grana-extra`,
          { email: vendedor.email }
        );
        setConcluido(true);
      }
      setLoadingVincular(false);
    } catch (error: any) {
      setLoadingVincular(false);
    }
  };

  const handleClearCpf = () => {
    setCPF('');
  };

  const onMaskedInput = () => {
    setCPF('');
    setExists(true);
    setCpfRegistered(false);
  };

  const handleLinNewSeller = () => {
    setConcluido(false);
    setExists(true);
    setVendedor({ nome: null, email: null });
    setCPF('');
  };

  const handleeManageProfiles = () => {
    window.location.href = '/corretor/leads/perfis';
  };

  const objtConclusionCard = {
    message: 'E-mail enviado com sucesso!',
    subMessage: `O e-mail foi enviado para o vendedor através do *${vendedor.email}* após o cadastro tente *vincular o cpf novamente.*`,
    handleFirstButtonAction: handleLinNewSeller,
    firstButtonLabel: 'Vincular novo vendedor',
    handleLastButtonAction: handleeManageProfiles,
    lastButtonLabel: '    Gerencie seus perfis'
  };

  useEffect(() => {
    const checkCpf = isCpfValid(cpf.replace('.', '').replace('-', ''));

    if (!checkCpf) {
      setDisableInputCPF(false);
    } else if (checkCpf) {
      setDisableInputCPF(true);
    }
  }, [cpf]);

  useEffect(() => {
    setConcluido(false);
  }, []);
  return (
    <LayoutGestaoLeads>
      <div className="tw-flex tw-flex-col tw-w-[100%] tw-mt-5 ">
        <div
          className={
            isMobile
              ? 'tw-flex tw-w-[100%] tw-justify-center tw-items-center tw-flex-col tw-px-[1rem]'
              : 'tw-flex tw-w-[100%] tw-justify-center tw-items-center tw-flex-col '
          }
        >
          {!concluido && (
            <div
              className={
                isMobile
                  ? 'tw-bg-[#F5F5F5] tw-w-[100%] tw-flex tw-flex-col tw-pt-[4vh] tw-rounded-3xl '
                  : 'tw-bg-[#F5F5F5] tw-w-[60vw] tw-flex tw-flex-col tw-pt-[4vh] tw-rounded-3xl '
              }
            >
              <div className="tw-flex tw-w-[100%] tw-px-[4vh] tw-justify-start ">
                <p className="tw-font-bold tw-text-[2.2vh]">Dados pessoais</p>
              </div>
              <div className="tw-px-[4vh] tw-mb-[2vh] tw-mt-2">
                <div
                  className={
                    isMobile
                      ? 'tw-flex tw-flex-col tw-w-[100%]'
                      : 'tw-flex tw-items-end'
                  }
                >
                  <div>
                    <p>CPF</p>
                    <div className="tw-relative">
                      <MaskedInput
                        mask={cpfMask}
                        value={cpf}
                        onInput={onMaskedInput}
                        onChange={(e) => {
                          setCPF(e.target.value);
                        }}
                        className={
                          isMobile
                            ? ` tw-border-[0.1rem] tw-w-[100%] tw-py-[0.5rem] tw-pl-2 tw-rounded-[0.3rem] ${
                                !exists || CpfRegistered
                                  ? 'tw-border-[#AA2C23]'
                                  : 'tw-border-[#001E64]'
                              }`
                            : ` tw-border-[0.1rem] tw-w-[22vw] tw-px-[0.8rem] tw-mr-[1rem] tw-py-[0.5rem] tw-rounded-[0.3rem] ${
                                !exists || CpfRegistered
                                  ? 'tw-border-[#AA2C23]'
                                  : 'tw-border-[#001E64]'
                              }`
                        }
                        id="cpf"
                        type="text"
                        placeholder="Digite CPF"
                      />
                      {vendedor.nome !== null && (
                        <div
                          className={
                            isMobile
                              ? 'tw-absolute tw-bottom-2 tw-right-[1rem]'
                              : 'tw-absolute tw-bottom-2 tw-right-[2rem]'
                          }
                        >
                          <HiCheckCircle size="1.5rem" color="#006217" />
                        </div>
                      )}
                      {CpfRegistered && cpf && (
                        <div className="tw-absolute tw-bottom-2 tw-right-[2rem]">
                          <IoCloseCircleOutline
                            size="1.5rem"
                            color="#AA2C23"
                            cursor="pointer"
                            onClick={handleClearCpf}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  {!exists && isMobile && (
                    <p className="tw-text-[#AA2C23]">CPF não localizado</p>
                  )}
                  {vendedor.nome !== null && isMobile && (
                    <div className="tw-mt-[2vh]">
                      <div>
                        <p className="tw-my-[1vh]">Nome</p>
                        <input
                          disabled
                          className={
                            isMobile
                              ? 'tw-border-[#001E64] tw-border-[0.1rem] tw-w-[100%] tw-px-[0.8rem] tw-py-[0.5rem] tw-rounded-[0.3rem]'
                              : 'tw-border-[#001E64] tw-border-[0.1rem] tw-w-[22vw] tw-px-[0.8rem] tw-py-[0.5rem] tw-rounded-[0.3rem]'
                          }
                          value={vendedor.nome}
                        ></input>
                      </div>
                    </div>
                  )}

                  <div>
                    <button
                      onClick={() => {
                        getCpfData(cpf);
                      }}
                      className={
                        isMobile
                          ? `tw-py-[0.5rem] tw-w-[100%] tw-text-center tw-h-[2.5rem] tw-mt-4 ${
                              disableInputCPF
                                ? 'tw-bg-[#146CFA]'
                                : 'tw-bg-[#AAAAAA]'
                            } tw-text-[#F5F5F5] tw-font-bold tw-rounded-3xl`
                          : `tw-py-[0.5rem] tw-px-[4vw] tw-flex tw-items-center ${
                              disableInputCPF
                                ? 'tw-bg-[#146CFA]'
                                : 'tw-bg-[#AAAAAA]'
                            } tw-text-[#F5F5F5] tw-font-bold tw-rounded-3xl`
                      }
                    >
                      Adicionar
                    </button>
                  </div>

                  {vendedor.nome !== null && isMobile && (
                    <div>
                      <p className="tw-my-[3vh] tw-border-b-2"></p>
                      <div>
                        <p className="tw-font-bold">
                          Você gostaria de vincular este CPF à sua corretora?
                        </p>
                        <p>
                          Se você confirmar, estará permitindo que este vendedor
                          receba
                          <br />
                          oportunidades de vendas e seja incluído na operação de
                          leads.
                        </p>
                      </div>
                    </div>
                  )}
                </div>
                {!exists && !isMobile && (
                  <p className="tw-text-[#AA2C23]">CPF não localizado</p>
                )}
                {vendedor.nome !== null && !isMobile && (
                  <div className="tw-mt-[2vh]">
                    <div className="tw-my-[2vh]">
                      <p className="tw-my-[1vh]">Nome</p>
                      <input
                        disabled
                        className={
                          'tw-border-[#001E64] tw-border-[0.1rem] tw-w-[22vw] tw-px-[0.8rem] tw-py-[0.5rem] tw-rounded-[0.3rem]'
                        }
                        value={vendedor.nome}
                      ></input>
                    </div>
                    <p className="tw-my-[3vh] tw-border-b-2"></p>
                    <div>
                      <p className="tw-font-bold">
                        Você gostaria de vincular este CPF à sua corretora?
                      </p>
                      <p>
                        Se você confirmar, estará permitindo que este vendedor
                        receba
                        <br />
                        oportunidades de vendas e seja incluído na operação de
                        leads.
                      </p>
                    </div>
                  </div>
                )}
                {!exists && (
                  <div className="tw-mt-[2vh]">
                    {isMobile ? (
                      <>
                        <p className="tw-my-[3vh] tw-border-b-2"></p>
                        <p>
                          Para prosseguir será necessário
                          <br />{' '}
                          <span className="tw-font-bold">
                            adicionar o e-mail do vendedor
                            <br /> para que ele possa realizar o cadastro
                            <br /> no site da campanha Grana Extra.
                          </span>
                        </p>
                      </>
                    ) : (
                      <p>
                        Para prosseguir será necessário{' '}
                        <span className="tw-font-bold">
                          adicionar o e-mail do vendedor
                          <br /> para que ele possa realizar o cadastro no site
                          da campanha Grana Extra.
                        </span>
                      </p>
                    )}
                    <p className="tw-my-[1vh]">E-mail</p>
                    <input
                      className={
                        isMobile
                          ? 'tw-border-[#001E64] tw-border-[0.1rem] tw-w-[100%] tw-px-[0.8rem] tw-py-[0.5rem] tw-rounded-[0.3rem]'
                          : 'tw-border-[#001E64] tw-border-[0.1rem] tw-w-[22vw] tw-px-[0.8rem] tw-py-[0.5rem] tw-rounded-[0.3rem]'
                      }
                      placeholder="E-mail"
                      onChange={(e) => {
                        setVendedor({ ...vendedor, email: e.target.value });
                      }}
                    ></input>
                  </div>
                )}
              </div>
              {(vendedor.nome !== null || vendedor.email !== null) && (
                <div
                  className={
                    isMobile
                      ? 'tw-w-[100%] tw-h-[14vh] tw-bg-[#FFFFFF] tw-rounded-[0_0_1.5rem_1.5rem] tw-shadow-[0px_0px_5px_rgba(50,50,50,0.25)]'
                      : 'tw-w-[100%] tw-h-[10vh] tw-bg-[#FFFFFF] tw-rounded-[0_0_1.5rem_1.5rem] tw-shadow-[0px_0px_5px_rgba(50,50,50,0.25)]'
                  }
                >
                  <div
                    className={
                      isMobile
                        ? 'tw-flex tw-flex-col-reverse tw-px-[4vh] tw-mt-[2vh]'
                        : 'tw-flex tw-justify-between tw-px-[4vh] tw-mt-[2vh]'
                    }
                  >
                    <button
                      disabled={loadingVincular === true}
                      onClick={() => {
                        setVendedor({ nome: null, email: null });
                        setExists(true);
                        setCPF('');
                      }}
                      className={
                        isMobile
                          ? 'tw-border-[#001E64] tw-border-[0.1rem] tw-mt-2 tw-text-[#001E64] tw-w-[100%] tw-h-[5vh] tw-rounded-3xl'
                          : 'tw-border-[#001E64] tw-border-[0.1rem] tw-text-[#001E64] tw-w-[10vw] tw-h-[5vh] tw-rounded-3xl'
                      }
                    >
                      Cancelar
                    </button>
                    {loadingVincular === false ? (
                      <button
                        onClick={() => {
                          handleVincularUsuario();
                        }}
                        className={
                          isMobile
                            ? 'tw-bg-[#FF5000] tw-text-[#EBEBEB] tw-font-bold tw-border-[0.1rem] tw-w-[100%] tw-h-[5vh] tw-rounded-3xl'
                            : 'tw-bg-[#FF5000] tw-text-[#EBEBEB] tw-font-bold tw-border-[0.1rem] tw-w-[10vw] tw-h-[5vh] tw-rounded-3xl'
                        }
                      >
                        Confirmar
                      </button>
                    ) : (
                      <button
                        disabled
                        className={
                          isMobile
                            ? 'tw-bg-[#FF5000] tw-flex tw-items-center tw-justify-center tw-text-[#EBEBEB] tw-font-bold tw-border-[0.1rem] tw-w-[100%] tw-h-[5vh] tw-rounded-3xl'
                            : 'tw-bg-[#FF5000] tw-flex tw-items-center tw-justify-center tw-text-[#EBEBEB] tw-font-bold tw-border-[0.1rem] tw-w-[10vw] tw-h-[5vh] tw-rounded-3xl'
                        }
                      >
                        <svg
                          className="tw-animate-spin tw-h-5 tw-w-5 tw-mr-3 "
                          viewBox="0 0 24 24"
                        >
                          <path
                            xmlns="http://www.w3.org/2000/svg"
                            d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
                            className="spinner_P7sC"
                            fill="white"
                          />
                        </svg>
                        Processando...
                      </button>
                    )}
                  </div>
                </div>
              )}
              {CpfRegistered && cpf && (
                <p className="tw-text-[#AA2C23] tw-px-[1.5rem] tw-w-[32vw] tw-mr-[1rem] tw-py-[0.5rem] tw-rounded-[0.3rem]">
                  {errorMessageIfCpfRegistered}
                </p>
              )}
            </div>
          )}
          {concluido && (
            <ConclusionCard objtConclusionCard={objtConclusionCard} />
          )}
        </div>
      </div>
    </LayoutGestaoLeads>
  );
}

export default CadastroVendedor;
